// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tuuJ","textarea":"styles_textarea__iBlo6"};